module.exports = require('eventsource')
